var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "715.000000pt",
    height: "715.000000pt",
    viewBox: "0 0 715.000000 715.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,715.000000) scale(0.100000,-0.100000)",
    fill: "red",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2873 6099 c-274 -32 -605 -146 -833 -286 -425 -263 -740 -657 -893 -1119 -77 -233 -107 -417 -107 -664 0 -247 30 -430 107 -665 225 -678 799 -1201 1498 -1363 294 -69 656 -69 950 0 274 63 598 217 793 376 l44 35 676 -676 c618 -617 681 -677 722 -687 167 -44 314 103 270 270 -10 41 -70 104 -687 722 l-676 676 35 44 c159 195 313 519 376 793 69 294 69 656 0 950 -198 853 -920 1495 -1793 1595 -104 11 -378 11 -482 -1z m450 -434 c377 -49 695 -205 962 -470 246 -246 397 -537 462 -895 23 -130 23 -410 0 -540 -65 -358 -214 -647 -462 -895 -164 -163 -350 -286 -555 -366 -537 -211 -1127 -134 -1595 208 -101 73 -262 235 -338 338 -368 502 -428 1150 -157 1711 303 627 992 1000 1683 909z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.c948a664cca80c2345567d7e54a4dae9.svg";
export { ForwardRef as ReactComponent };